import { useMap } from "react-leaflet";
import { useEffect } from "react";
import L from "leaflet";

export default function FitToPoint({ lat, lng, radius }) {
	const map = useMap();
	useEffect(() => {
		const bounds = L.latLng(lat, lng).toBounds(radius);
		map.fitBounds(bounds, { animate: true });
	}, [lat, lng, radius]);
	return null;
}